import userReducer from './reducers/userReducer'
import { createStore } from 'redux'

export default createStore(userReducer)
